import { render } from "./KardexCliente.vue?vue&type=template&id=5860a3f8"
import script from "./KardexCliente.vue?vue&type=script&lang=js"
export * from "./KardexCliente.vue?vue&type=script&lang=js"

import "./KardexCliente.vue?vue&type=style&index=0&id=5860a3f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__